module.exports = __webpack_public_path__ + "assets/img/perfect_6.e8bb4ed3.png";